import './App.scss'
import Home from 'pages/Home'
export default function App() {
  return (
    <div className="App">
      <Home />
    </div>
  )
}
